export default __webpack_public_path__ + "static/media/img_21.ab5c9cf7.jpg";